<template>
    <Box  @close="cerrar(false)" v-if="cliente">
        <template #top>Cliente</template>
        <template #center>
            <div class="nj-cols">
                <div class="nj-cols c2">
                    <div>
                        <div class="nj-label">Tipo de documento</div>
                        <input type="text" class="nj-text" v-model="cliente.cli_tipo_documento_identidad_nombre" disabled>
                    </div>
                    <div>
                        <div class="nj-label">Documento</div>
                        <input type="text" class="nj-text" v-model="cliente.cli_documento_identidad" disabled>
                    </div>
                </div>
                <div>
                    <div class="nj-label">Nombres y apellidos / Razón Social</div>
                    <input type="text" class="nj-text" v-model="cliente.cli_nombre" disabled>
                </div>
                <div>
                    <div class="nj-label">Domicilio Fiscal</div>
                    <input type="text" class="nj-text" v-model="cliente.cli_domicilio_fiscal" disabled>
                </div>
                <div class="nj-cols c2">
                    <div>
                        <div class="nj-label">Correo</div>
                        <input type="text" class="nj-text" v-model="cliente.cli_correo" disabled>
                    </div>
                    <div>
                        <div class="nj-label">Teléfono / Celular</div>
                        <input type="text" class="nj-text" v-model="cliente.cli_telefono" disabled>
                    </div>
                </div>
                <div>
                    <div class="nj-label">Nombres y apellidos del contacto</div>
                    <input type="text" class="nj-text" v-model="cliente.cli_nombre_contacto" disabled>
                </div>
            </div>
            <br>
            <br>
            <div class="nj-subtitle-1">Direcciones de Envío</div>
            <br>
            <b-table :data="cliente.lista_cliente_direccion_envio">
                <template slot-scope=" props">
                    <b-table-column label="Dirección" header-class="is-info">{{ props.row.ubi_id }}</b-table-column>
                    <b-table-column label="Referencia" header-class="is-info">{{ props.row.cde_referencia }}</b-table-column>
                    <b-table-column label="Ciudad" header-class="is-info">{{ props.row.ubi_id }}</b-table-column>
                    <b-table-column label="Alias" header-class="is-info">{{ props.row.cde_alias }}</b-table-column>
                </template>
            </b-table>
        </template>
    </Box>
</template>

<script>
import { ClienteService, ResponseStatus } from "../../services"
import Toast from "../../util/toast"
import { Box } from "../components"

export default {
    name: "VerCliente",
    components: {
        Box
    },
    data() {
        return {
            cliente: null,
            sequence: 1,
            cliente_direccion_envio: {
                ubi_id: null,
                cde_referencia: null,
                ubi_id: null,
                cde_alias: null,
            },
        }
    },
    props: {
        cli_id: {
            type: Number
        },
    },
    methods: {
        modificar() {
            let errors = 0
            if (this.cliente.cli_tipo_documento_identidad == null) errors++
            if (this.cliente.cli_documento_identidad == null) errors++
            if (this.cliente.cli_nombre == null) errors++
            if (this.cliente.cli_nombre_contacto == null) errors++
            if (this.cliente.cli_domicilio_fiscal == null) errors++
            if (this.cliente.cli_correo == null) errors++
            if (this.cliente.cli_telefono == null) errors++
            if (this.cliente.lista_cliente_direccion_envio.length == 0) errors++
            if (errors == 0) {
                ClienteService.modificar({
                    cliente: this.cliente
                }).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.cerrar(true)
                        }
                        else {
                            Toast.error(response.message)
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
            else {
                Toast.error("Falta ingresar datos para registrar al cliente")
            }
        },
        agregarDireccion() {
            let errors = 0
            if (!this.cliente_direccion_envio.ubi_id) errors++
            if (!this.cliente_direccion_envio.cde_referencia) errors++
            if (!this.cliente_direccion_envio.ubi_id) errors++
            if (!this.cliente_direccion_envio.cde_alias) errors++
            if (errors == 0) {
                this.sequence++
                this.cliente.lista_cliente_direccion_envio.push({
                    cde_sequence: this.sequence,
                    ubi_id: this.cliente_direccion_envio.ubi_id,
                    cde_referencia: this.cliente_direccion_envio.cde_referencia,
                    ubi_id: this.cliente_direccion_envio.ubi_id,
                    cde_alias: this.cliente_direccion_envio.cde_alias,
                })
                this.cliente_direccion_envio.ubi_id = null
                this.cliente_direccion_envio.cde_referencia = null
                this.cliente_direccion_envio.ubi_id = null
                this.cliente_direccion_envio.cde_alias = null
            }
            else {
                Toast.error("Falta ingresar datos para agregar la dirección de envio")
            }
        },
        removerDireccion(sequence) {
            this.cliente.lista_cliente_direccion_envio = this.cliente.lista_cliente_direccion_envio.filter(item => item.cde_sequence != sequence)
        },
        reiniciar() {

        },
        cerrar(condition) {
            this.$emit("close", { componente: "ver", abrir: false, buscar: condition })
        }
    },
    mounted() {
        ClienteService.obtener({
            cliente: {
                cli_id: this.cli_id
            }
        }).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.cliente = response.data
                }
                else {
                    Toast.error(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>